import CssBaseline from "@mui/material/CssBaseline"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { Link } from "@mui/material"
import { AppMenu, AppMenuItem } from "./components/Menu"
import LoginRoute from "./routes/login"

import "./App.css"
import OtpRoute from "./routes/login/otp"
import PodConnectionManager from "./routes/podoffload/PodConnectionManager"

function App() {
  return (
    <BrowserRouter>
      <div className="hux-app">
        <CssBaseline />

        <header className="hux-header">
          <Link href="/">
            <img
              className="hux-logo"
              alt="Huxley Logo"
              src="/img/HUXLEY_CENTERED_Small.png"
            />
          </Link>

          <AppMenu>
            <AppMenuItem to="/device">Create Device</AppMenuItem>
          </AppMenu>
        </header>

        <div className="hux-content">
          <Routes>
            <Route path="/" element={<LoginRoute />} />
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/otp" element={<OtpRoute />} />
            <Route path="/device" element={<PodConnectionManager />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  )
}

export default App
